import { createSlice } from '@reduxjs/toolkit'
import { PermissionsServerData } from '@lk/api'

import { loadPermissions } from './permissions.actions'

export interface PermissionsState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: PermissionsServerData
  error: string | null
}

const initialState = {
  status: 'idle',
  data: {},
  error: null,
}

export const permissionsReducer = createSlice({
  name: 'permissions',
  initialState,
  reducers: {},
  extraReducers: {
    [loadPermissions.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadPermissions.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadPermissions.rejected.toString()]: (state) => {
      state.status = 'failed'
      state.error = 'Failed to load permissions'
    },
  },
}).reducer
